import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AnimatedLogo = ({ className = "" }) => {
  const [showOrigin, setShowOrigin] = useState(false);

  useEffect(() => {
    // Different durations: Transplacement = 3s, Transparent Placement = 1.5s
    const duration = showOrigin ? 1500 : 3000;
    const timeout = setTimeout(() => {
      setShowOrigin(prev => !prev);
    }, duration);
    return () => clearTimeout(timeout);
  }, [showOrigin]);

  return (
    <Link to="/" className={`font-heading text-lg sm:text-xl font-semibold tracking-tight relative block min-w-[180px] ${className}`} data-testid="logo">
      <AnimatePresence mode="wait">
        {showOrigin ? (
          <motion.span
            key="origin"
            initial={{ opacity: 0, y: 8, filter: "blur(4px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            exit={{ opacity: 0, y: -8, filter: "blur(4px)" }}
            transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
            className="flex items-center gap-1"
            style={{ color: "#6b7280" }}
          >
            Transparent <ArrowRight className="h-4 w-4 inline" /> Placement
          </motion.span>
        ) : (
          <motion.span
            key="brand"
            initial={{ opacity: 0, y: 8, filter: "blur(4px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            exit={{ opacity: 0, y: -8, filter: "blur(4px)" }}
            transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
            className="block"
          >
            Transplacement
          </motion.span>
        )}
      </AnimatePresence>
    </Link>
  );
};

export default AnimatedLogo;
